module.exports = __webpack_public_path__ + "static/img/zg1.1.1fa0f99.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/geren/newqietu/mgnew/zg1.1.jpeg
// module id = 01h2
// module chunks = 36